import { v4 as uuid } from 'uuid';
import { DiscountType, PACKAGE_REDEEM_DISCOUNT_SOURCE } from './constants';
import { IService, IStaffItem } from './types/api';
import { SERVICE_ITEM_TYPE } from './types/constant';
import { ICustomerServicePackage } from './types/customer-service-package';

/**
 * Một buổi dùng gói = một dòng trên ticket.
 * Khách trả $0 nhờ discount đúng bằng giá, nhưng discount ghi owner chịu 100% nên staff
 * vẫn được tính commission trên giá buổi đó — giống cách VIP package và stamp reward đang làm.
 */
export const buildUsePackageService = (pkg: ICustomerServicePackage): IService => ({
  itemId: pkg.id,
  itemName: pkg.programName,
  itemType: SERVICE_ITEM_TYPE.USE_PACKAGE,
  price: pkg.pricePerSession || 0,
  discount: pkg.pricePerSession || 0,
  discountType: DiscountType.MONEY,
  discountSetting: { ownerPaidPercent: 100, staffPaidPercent: 0, source: PACKAGE_REDEEM_DISCOUNT_SOURCE },
  duration: 0,
  note: null,
  uuid_local: uuid(),
});

/** Số buổi của gói đã nằm trên ticket hiện tại */
export const countUsedSessions = (selectedItems: IStaffItem[], packageId: string): number =>
  (selectedItems || []).reduce(
    (total, staff) =>
      total +
      (staff.services || []).filter(
        (service) => service.itemType === SERVICE_ITEM_TYPE.USE_PACKAGE && service.itemId === packageId,
      ).length,
    0,
  );

/**
 * Số buổi còn thêm được vào ticket.
 * BE chỉ trừ usedQuantity sau khi thanh toán, nên trong lúc ticket còn mở phải tự trừ
 * các dòng đang có. Xoá dòng là buổi tự trả lại, không cần state riêng.
 */
export const getUsableSessions = (selectedItems: IStaffItem[], pkg: ICustomerServicePackage): number =>
  Math.max((pkg.remainingQuantity || 0) - countUsedSessions(selectedItems, pkg.id), 0);

/** Ticket đang có dòng dùng gói nào không — các dòng này gắn chặt với khách đang chọn */
export const hasUsePackageLine = (selectedItems: IStaffItem[]): boolean =>
  (selectedItems || []).some((staff) =>
    (staff.services || []).some((service) => service.itemType === SERVICE_ITEM_TYPE.USE_PACKAGE),
  );
